import { MijnRoute } from '../../mijn-navigatie.model';

export const PAYMENTS_PIGGYBANK_SUMMARY: MijnRoute = {
    path: 'spaarpot',
    navigationEvent: 'toOverboekenSpaarpot',
    regex: /^\/overboeken\/spaarpot$/,
    webcomponent: 'mijn-overboeken-webcomponent',
    internalPath: '/spaarpot'
};
